import { MsalProvider } from "@azure/msal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./assets/styles/index.scss";
import "react-toastify/dist/ReactToastify.css";
import { PATHS } from "./constants/PATHS";
import { pca } from "./msal";
import queryClient from "./query";
// import { SignalRContextProvider } from "./signalR";
import { store } from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const debugCookie = document.cookie.split("; ").find((row) => row.startsWith("debug="));

root.render(
  <React.StrictMode>
    <BrowserRouter basename={PATHS.BASE_PATH}>
      <MsalProvider instance={pca}>
        <CookiesProvider>
          {/* <SignalRContextProvider> */}
            <QueryClientProvider client={queryClient}>
              {debugCookie && <ReactQueryDevtools initialIsOpen={false} />}
              <Provider store={store}>
                <App />
              </Provider>
            </QueryClientProvider>
          {/* </SignalRContextProvider> */}
        </CookiesProvider>
      </MsalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
